import React, { useState, MouseEvent } from 'react';
import classNames from "classnames";
import InfoTable from './infoTable';
import useBus from 'use-bus';

const Subcategory = ({ subcategory }: any) => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleCollapse = (): void => {
        setIsVisible(!isVisible);
    };

    const onClickLink = (event: MouseEvent<HTMLAnchorElement>): void => {
        event.stopPropagation();
    };

    useBus(
        'ui/expand',
        () => setIsVisible(true)
    );

    useBus(
        'ui/collapse',
        () => setIsVisible(false)
    );

    return (
        <div>
            <div
                className="flex items-center px-3 py-2 text-gray-700 cursor-pointer group hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 border-b border-gray-100 dark:border-gray-800 dark:text-gray-400 "
                onClick={toggleCollapse}
            >
                <h3 className="flex-1 font-mono text-sm">{subcategory.title}</h3>
                {subcategory.version ? (
                    <span className="px-2 py-1 text-xs font-bold text-white bg-gray-400 dark:bg-gray-800 dark:group-hover:bg-gray-700 rounded-md">v{subcategory.version}</span>
                ) : null}
                {!isVisible ? (
                    <svg className="w-5 h-5 text-gray-700 dark:text-gray-400  my-2 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                ) : (
                    <svg className="w-5 h-5 text-gray-700 dark:text-gray-400  my-2 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd"></path></svg>
                )}
            </div>
            <div className={classNames('bg-gray-100 dark:bg-gray-800 px-3 overflow-hidden', {
                'h-0': !isVisible
            })}>
                <p className="my-3 font-semibold leading-tight text-gray-800 dark:text-gray-400 text-sm">{subcategory.description} <a
                    className="text-xs font-mono text-gray-800 dark:text-gray-400 hover:underline ml-1"
                    href={subcategory.docs}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={onClickLink}
                >
                    [view docs]
                </a></p>
                <InfoTable table={subcategory.table} />
            </div>
        </div>
    );
}

export default Subcategory;
